import { UniFiCategoryId, UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/Switching/pro-xg-8-poe@2x.jpg";
import v3Image from "../../assets/Switching/proXg8PoE.jpg";
import { type Product } from "../../types";
import { productListSwitchingCompact } from "../product-list-groups/productListSwitchingCompact";
import {
  downlinkSpeed,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  ports,
  powerMethod,
  uplinkSpeed,
} from "../properties";

export const proXg8PoE: Product = {
  id: "proXg8PoE",
  productTitle: "Pro XG 8 PoE",
  description: "proXg8PoE.description",
  storePathParts: {
    category: UniFiChildCategorySlug.SwitchingUtility,
    productSlug: "usw-pro-xg-8-poe",
  },
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.Switching}/usw-pro-xg-8-poe`,
  ],
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 243,
    height: 120,
  },
  isNew: true,
  productListGroup: productListSwitchingCompact,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '210.4 x 173.8 x 43.7 mm\n(8.28 x 6.84 x 1.7")',
      },
    },
    {
      propertyId: "portCount",
      value: { type: "string", value: "10" },
    },
    {
      propertyId: ports.id,
      value: {
        type: "string",
        value: "(8) 10 GbE RJ45\n(2) 10G SFP+",
      },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "string",
        value: "10 Gbps",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: {
        type: "string",
        value: "10 Gbps",
      },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "string",
        value: "PoE++",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: {
        type: "string",
        value: "155 W",
      },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.desktopWall",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "boolean",
        value: false,
      },
    },
    {
      propertyId: "etherlighting",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "proAvSupport",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "boolean",
        value: false,
      },
    },
  ],
};
